export default __webpack_public_path__ + "static/media/material1.360b07e1.png";